
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import Table from 'react-bootstrap/Table';
import Navbar4 from '../../../Components/Navbar4';
import './Dean_HOD.css';
import { API_BASE_URL } from '../../../config';
import { useNavigate } from 'react-router-dom';

export default function Dean_HOD() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const app_ID = query.get('app_ID');
  const [application, setApplication] = useState(null);
  const [decision, setDecision] = useState('');
  const [remarks, setRemarks] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchApplicationDetails = async () => {
      if (app_ID) {
        try {
          const response = await axios.get(`${API_BASE_URL}/DeanHOD.php?app_ID=${app_ID}`);
          setApplication(response.data);
        } catch (error) {
          console.error('Error fetching application details:', error);
          setApplication({ error: "Failed to fetch application details." });
        }
      } else {
        setApplication({ error: "No app_ID provided." });
      }
    };

    fetchApplicationDetails();
  }, [app_ID]);

  const handleMarksSubmit = async () => {
    // Validate that decision and remarks are not empty
    if (!decision || !remarks) {
      setErrorMessage('Both decision and remarks are required.');
      return;
    }

    setErrorMessage(''); // Clear previous error message

    const approvalCode = decision === 'approved' ? '3.1' : '3.2';

    try {
      // Send data to the backend for database update
      const response = await axios.post(`${API_BASE_URL}/DeanEvaluvation.php`, {
        app_ID,
         decision: approvalCode,
        // hod_approval: approvalCode,
        remarks
      });

      if (response.data.success) {
        navigate('/popup2'); // Navigate to /popup after successful submission
      } else {
        alert('Failed to submit. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting data:', error);
      alert('An error occurred. Please try again.');
    }
  };

  if (!application) {
    return <div>Loading...</div>;
  }

  if (application.error) {
    return <div>{application.error}</div>;
  }

  const handleViewClick = async (app_ID) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/ViewSubmittedApplicationPDF.php?app_ID=${app_ID}`, {
        responseType: 'blob', // Expect binary data (PDF file)
      });
  
      // Create a Blob object and generate a download link
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      // link.download = `Application_${app_ID}.pdf`; // Set the downloaded file's name
      link.download = `Application_${new Date().getFullYear()}_${app_ID}.pdf`;
      link.click();
  
      // Cleanup
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error('Error downloading the file:', error);
      alert('An error occurred while downloading the application.');
    }
  };
  

  return (
    <div>
      <Navbar4 />
      <h1 className='dpage-title'>Dean</h1>
      <h1 className="dpage-title">Application ID: {application.app_ID}_{new Date().getFullYear()}</h1>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Project Title</th>
            <th>Applicant Name</th>
            <th>View</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{application.projectTitle}</td>
            <td>{application.name}</td>
            <td>
              <button
                className="view-button"
                onClick={() => handleViewClick(application.app_ID)}
              >
                View
              </button>
            </td>
          </tr>
        </tbody>
      </Table>

      <div className="marks-section">
        {errorMessage && <p className="error-message">{errorMessage}</p>}
        
        <div className="decision-section">
          <label htmlFor="decision">Decision: </label>
          <select
            id="decision"
            value={decision}
            onChange={(e) => setDecision(e.target.value)}
            className="decision-input"
            required
          >
            <option value="">Select Decision</option>
            <option value="approved">Approved</option>
            <option value="rejected">Rejected</option>
          </select>
        </div>

        <div className="remarks-section">
          <label htmlFor="remarks" className="remarks-label">Remarks:</label>
          <textarea
            id="remarks"
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            placeholder="Enter remarks"
            className="remarks-input"
            rows={3}
            required
          />
        </div>

        <button 
          className="submit-button" 
          onClick={handleMarksSubmit}
        >
          Submit
        </button>
      </div>
    </div>
  );
}